export const CREATE_SUPER_DEAL = 'CREATE_SUPER_DEAL';
export const CREATE_SUPER_DEAL_SUCCESS = 'CREATE_SUPER_DEAL_SUCCESS';
export const CREATE_SUPER_DEAL_FAILS = 'CREATE_SUPER_DEAL_FAILS';

export const FETCH_SUPER_DEALS = 'FETCH_SUPER_DEALS';
export const FETCH_SUPER_DEALS_SUCCESS = 'FETCH_SUPER_DEALS_SUCCESS';
export const FETCH_SUPER_DEALS_FAILS = 'FETCH_SUPER_DEALS_FAILS';

export const DELETE_SUPER_DEAL = 'DELETE_SUPER_DEAL';
export const DELETE_SUPER_DEAL_SUCCESS = 'DELETE_SUPER_DEAL_SUCCESS';
export const DELETE_SUPER_DEAL_FAILS = 'DELETE_SUPER_DEAL_FAILS';
